import React, { useState } from 'react';

import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material';

import PageSubheader from '~/components/Common/Elements/PageSubheader';

import ReopenManagementPane from './ReopenManagementPane';
import StopsellManagementPane from './StopsellManagementPane';

type Mode = 'stopsell' | 'reopen';

interface Props {
  propertyId: string;
  roomTypes: Array<App.RoomType>;
  offers: Array<App.Offer>;
}

export default function AvailabilityManagementPane({ propertyId, roomTypes }: Props) {
  const [mode, setMode] = useState<Mode>('stopsell');

  const handleModeChange = (_: React.MouseEvent<HTMLElement>, value: Mode | null) => {
    if (value) setMode(value);
  };

  return (
    <>
      <PageSubheader title="Availability Management" />

      <Box mb={2}>
        <ToggleButtonGroup value={mode} exclusive onChange={handleModeChange} size="small">
          <ToggleButton value="stopsell">Stopsell</ToggleButton>
          <ToggleButton value="reopen">Re-open</ToggleButton>
        </ToggleButtonGroup>
      </Box>

      {mode === 'stopsell' && <StopsellManagementPane propertyId={propertyId} roomTypes={roomTypes} hideHeader />}
      {mode === 'reopen' && <ReopenManagementPane propertyId={propertyId} roomTypes={roomTypes} hideHeader />}
    </>
  );
}
